import { buildSectionSelector, normalizeSectionId, sectionRenderer } from "@theme/section-renderer";
import { requestIdleCallback, onDocumentReady } from "@theme/utilities";
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));
  if (!section || section.dataset.hydrated === "true") {
    return;
  }
  await sectionRenderer.renderSection(normalizedId, { cache: false, url, mode: "hydration" });
  section.dataset.hydrated = "true";
}
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
